import Vue from 'vue'
import Router from 'vue-router'
import bannerMaster from '@/view/store/banner_master/banner_master'
import bannerDetail from '@/view/store/banner_master/banner_detail.vue'
import bannerProcessDetail from '@/view/store/banner_master/banner_process_detail.vue'
import storeCentralMapping from '@/view/store/store_central/store_central_mapping.vue'
import dataQualityChecking from '@/view/store/data_quality/data_quality_checking.vue'
import userList from '@/view/acs/user/user_list.vue'
import functionMgmt from '@/view/acs/function_permission/function_mgmt.vue'
import roleList from '@/view/acs/role/role_list.vue'
import tagList from '@/view/acs/tag/tag_list.vue'
import tagList1 from '@/view/acs/tag/tag_list1.vue'
import tagList2 from '@/view/acs/tag/tag_list2.vue'
import fieldTag from '@/view/acs/table/config_field_tag.vue'
import testTree from '@/view/acs/test.vue'
import switchRole from '@/view/switch_role'
import noPermissionUrl from '@/view/no_permission_url'
import pictureDisplay from '@/components/d1/picture-display'
import productPrice from './product-price';
import dashboard from './dashboard';
import cmr from './cmr';
import mdm from './mdm'

//维护展示页面
import versionMaintenance from '@/view/version_maintenance.vue'

Vue.use(Router)
const routerPush = Router.prototype.push
const routerReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error=> error)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'full',
      redirect: '/login',
      component: resolve => require(['@/containers/Full'], resolve),
      children: [

        {
          path: 'menu',
          name: 'menu',
          component: resolve => require(['@/view/menu'], resolve)
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['@/view/home/home'], resolve)
        },
        {
          path: 'store-banner-mapping',
          name: 'store_banner_mapping',
          component: resolve => require(['@/view/store/store_banner_mapping/store_banner_mapping'], resolve)
        },
        {
          path: 'backlog',
          name: 'backlog',
          component: resolve => require(['@/view/store/pending/MyToDoList.vue'], resolve),
        },
        {
          path: 'one-store-confirmation',
          name: 'one-store-confirmation',
          component: resolve => require(['@/view/store/one_store/one_store_confirmation.vue'], resolve),
        },
        {
          path: 'one-store-confirmation/detail',
          name: 'one-store-confirmation-detail',
          component: resolve => require(['@/view/store/one_store/one_store_confirmation_detail.vue'], resolve),
        },
        {
          path: 'one-store-report',
          name: 'one-store-report',
          component: resolve => require(['@/view/store/one_store/one_store_report.vue'], resolve),
        },
        {
          path: 'store-detail',
          name: 'store-detail',
          component: resolve => require(['@/components/distributor_store/store_detail.vue'], resolve)
        },
        {
          path: 'store-process-detail',
          name: 'store-process-detail',
          component: resolve => require(['@/components/distributor_store/store_process_detail.vue'], resolve)
        },
        {
          path: 'ticket-approval',
          name: 'ticket-approval',
          component: resolve => require(['@/components/distributor_store/TicketApproval.vue'], resolve)
        },
        {
          path: 'approval-process',
          name: 'approval-process',
          component: resolve => require(['@/components/distributor_store/ApprovalProcess.vue'], resolve)
        },
        {
          path: 'banner-master',
          name: 'banner-master',
          component: bannerMaster
        },
        {
          path: 'banner-detail',
          name: 'banner-detail',
          component: bannerDetail
        },
        {
          path: 'banner-process-detail',
          name: 'banner-process-detail',
          component: bannerProcessDetail
        },
        {
          path: 'store-central-mapping',
          name: 'store-central-mapping',
          component: storeCentralMapping
        },
        {
          path: 'e-store-list',
          name: 'e-store-list',
          component: resolve => require(['@/view/store/e_store/e_store_list.vue'], resolve)
        },
        {
          path: 'e-store-report',
          name: 'e-store-report',
          component: resolve => require(['@/view/store/e_store/e_store_report.vue'], resolve)
        },
        {
          path: 'e-store/storeAdd',
          name: 'storeAdd',
          component: resolve => require(['@/view/store/e_store/StoreCreateOrEdit.vue'], resolve)
        },
        {
          path: 'e-store/storeDetail',
          name: 'storeDetail',
          component: resolve => require(['@/view/store/e_store/StoreDetail.vue'], resolve)
        },
        {
          path: 'e-store/storeEdit',
          name: 'storeEdit',
          component: resolve => require(['@/view/store/e_store/StoreCreateOrEdit.vue'], resolve)
        },
        {
          path: 'e-store/MyToDoList',
          name: 'MyToDoList',
          component: resolve => require(['@/view/store/e_store/MyToDoList.vue'], resolve)
        },
        {
          path: 'e-store/MyRequests',
          name: 'MyRequests',
          component: resolve => require(['@/view/store/e_store/MyRequests.vue'], resolve)
        },
        {
          path: 'e-store/TicketDetails',
          name: 'TicketDetails',
          component: resolve => require(['@/view/store/e_store/TicketDetails.vue'], resolve)
        },
        {
          path: 'data-quality-checking',
          name: 'data-quality-checking',
          component: dataQualityChecking
        },
        {
          path: 'user-list',
          name: 'user-list',
          component: userList
        },
        {
          path: 'function-mgmt',
          name: 'function-mgmt',
          component: functionMgmt
        },
        {
          path: 'maintain-mgmt',
          name: 'maintain-mgmt',
          component: resolve => require(['@/view/acs/maintainPage/index.vue'], resolve)
        },
        {
          path: 'role-list',
          name: 'role-list',
          component: roleList
        },

        {
          path: 'tag-list',
          name: 'tag-list',
          component: tagList
        },
        {
          path: 'tag-list1',
          name: 'tag-list1',
          component: tagList1
        },
        {
          path: 'tag-list2',
          name: 'tag-list2',
          component: tagList2
        },
        {
          path: 'config-field-tag',
          name: 'config-field-tag',
          component: fieldTag
        },

        {
          path: '404',
          name: '404',
          component: noPermissionUrl
        },
        {
          path:'segmentationPage',
          name:'segmentationPage',
          component : resolve =>require(['@/view/store/segmentation/segmentation_page.vue'],resolve)
        },

        {
          path: 'poh/detail',
          name: 'pohDetail',
          component: resolve => require(['@/view/POH/detail'], resolve)
        },
        {
          path: 'poh/maintain',
          name: 'pohMaintain',
          component: resolve => require(['@/view/POH/maintain'], resolve)
        },
        {
          path: 'poh/clinic-master-data',
          name: 'pohMaintainMasterData',
          component: resolve => require(['@/view/POH/clinic-master-data'], resolve)
        },
        {
          path: 'poh/ticketDetail',
          name: 'pohTicketDetail',
          component: resolve => require(['@/view/POH/ticketDetail'], resolve)
        },
        {
          path: 'poh/dental',
          name: 'pohDental',
          component: resolve => require(['@/view/POH/dental'], resolve)
        },
        {
          path: 'poh/dental-master-data',
          name: 'pohDentalMasterData',
          component: resolve => require(['@/view/POH/dental-master-data'], resolve)
        },
        {
          path: 'poh/delegation',
          name: 'delegation',
          component: resolve => require(['@/view/POH/delegation'], resolve)
        },
        {
          path: 'poh/clinic-draft',
          name: 'clinicDraft',
          component: resolve => require(['@/view/POH/draft'], resolve)
        },
        /**CMR */
        {
          path: '/cmr/MaintainProductHierarchy',
          name: 'MaintainProductHierarchy',
          component: resolve => require(['@/view/cmr/maintain-product-hierarchy/MaintainProductHierarchyList.vue'], resolve)
        },
        {
          path: '/cmr/MaintainProductHierarchyDetail',
          name: 'MaintainProductHierarchyDetail',
          component: resolve => require(['@/view/cmr/maintain-product-hierarchy/MaintainProductHierarchyDetail.vue'], resolve)
        },
        {
          path: '/cmr/MaintainProductHierarchyEdit',
          name: 'MaintainProductHierarchyEdit',
          component: resolve => require(['@/view/cmr/maintain-product-hierarchy/MaintainProductHierarchyEdit.vue'], resolve)
        },
        {
          path: '/cmr/ProductMasterData',
          name: 'ProductMasterData',
          component: resolve => require(['@/view/cmr/report-center/ProductMasterData.vue'], resolve)
        },
        {
          path: '/cmr/ProductLocalHierarchy',
          name: 'ProductLocalHierarchy',
          component: resolve => require(['@/view/cmr/report-center/ProductLocalHierarchy.vue'], resolve)
        },
        {
          path: '/cmr/PowerSKUProductList',
          name: 'PowerSKUProductList',
          component: resolve => require(['@/view/cmr/report-center/PowerSKUProductList.vue'], resolve)
        },
        {
          path: '/cmr/PSKUTarget',
          name: 'PSKUTarget',
          component: resolve => require(['@/view/cmr/report-center/PSKUTargetList.vue'], resolve)
        },
        {
          path: '/cmr/CustomerMasterReportFull',
          name: 'CustomerMasterReportFull',
          component: resolve => require(['@/view/cmr/report-center/CustomerMasterReportFull.vue'], resolve)
        },
        {
          path: '/cmr/CustomerMasterReportSimple',
          name: 'CustomerMasterReportSimple',
          component: resolve => require(['@/view/cmr/report-center/CustomerMasterReportSimple.vue'], resolve)
        },
        {
          path: '/cmr/DPartnerShiptoReport',
          name: 'DPartnerShiptoReport',
          component: resolve => require(['@/view/cmr/report-center/DPartnerShiptoReport.vue'], resolve)
        },
        {
          path: '/cmr/iOMNIRRStoreMaster',
          name: 'iOMNIRRStoreMaster',
          component: resolve => require(['@/view/cmr/report-center/iOMNIRRStoreMaster.vue'], resolve)
        },
        {
          path: '/cmr/iOMNIStoreMasterISAHC',
          name: 'iOMNIStoreMasterISAHC',
          component: resolve => require(['@/view/cmr/report-center/iOMNIStoreMasterISAHC.vue'], resolve)
        },
        {
          path: '/cmr/iOMNIStoreNOCReport',
          name: 'iOMNIStoreNOCReport',
          component: resolve => require(['@/view/cmr/report-center/iOMNIStoreNOCReport.vue'], resolve)
        },
        {
          path: '/cmr/SEOCoverage',
          name: 'SEOCoverage',
          component: resolve => require(['@/view/cmr/report-center/SEOCoverage.vue'], resolve)
        },
        {
          path: '/cmr/PartyRoleTypeRegulate',
          name: 'PartyRoleTypeRegulate',
          component: resolve => require(['@/view/cmr/report-center/PartyRoleTypeRegulate.vue'], resolve)
        },
        {
          path: '/cmr/GeographyData',
          name: 'GeographyData',
          component: resolve => require(['@/view/cmr/report-center/GeographyData.vue'], resolve)
        },
        {
          path: '/cmr/MyPosProduct',
          name: 'MyPosProduct',
          component: resolve => require(['@/view/cmr/post-master-data/MyPostProduct.vue'], resolve)
        },
        {
          path: '/cmr/MyPosStore',
          name: 'MyPosStore',
          component: resolve => require(['@/view/cmr/post-master-data/MyPostStore.vue'], resolve)
        },
        {
          path: '/cmr/PosStoreCreate',
          name: 'PosStoreCreate',
          component: resolve => require(['@/view/cmr/post-master-data/PosStoreCreate.vue'], resolve)
        },
        {
          path: '/cmr/MyStores',
          name: 'MyStores',
          component: resolve => require(['@/view/cmr/my-stores/MyStores.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresCreate',
          name: 'Create',
          component: resolve => require(['@/view/cmr/my-stores/StoreCreateOrEdit.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresEdit',
          name: 'Edit',
          component: resolve => require(['@/view/cmr/my-stores/StoreCreateOrEdit.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresApprover',
          name: 'MyStoresApprover',
          component: resolve => require(['@/view/cmr/my-stores/MyStoresApprover.vue'], resolve)
        },
        {
          path: '/cmr/MediaFormat',
          name: 'MediaFormat',
          component: resolve => require(['@/view/cmr/media/MediaFormat.vue'], resolve)
        },
        {
          path: '/cmr/MediaFormatCreate',
          name: 'Create',
          component: resolve => require(['@/view/cmr/media/MediaFormatCreateOrEdit.vue'], resolve)
        },
        {
          path: '/cmr/MediaFormatEdit',
          name: 'Edit',
          component: resolve => require(['@/view/cmr/media/MediaFormatCreateOrEdit.vue'], resolve)
        },
        {
          path: '/cmr/MediaFormatApprover',
          name: 'MediaFormatApprover',
          component: resolve => require(['@/view/cmr/media/MediaFormatApprover.vue'], resolve)
        },
        {
          path: '/cmr/MyShipTo',
          name: 'MyShipTo',
          component: resolve => require(['@/view/cmr/my-ship-to/MyShipTo.vue'], resolve)
        },
        {
          path: '/cmr/EditShipTo',
          name: 'EditShipTo',
          component: resolve => require(['@/view/cmr/my-ship-to/EditShipTo.vue'], resolve)
        },
        {
          path: '/cmr/MatchingExistingStore',
          name: 'MatchingExistingStore',
          component: resolve => require(['@/view/cmr/post-master-data/MatchingExistingStore.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresView',
          name: 'MyStoresView',
          component: resolve => require(['@/view/cmr/my-stores/MyStoresView.vue'], resolve)
        },
        {
          path: '/cmr/MyShipToView',
          name: 'MyShipToView',
          component: resolve => require(['@/view/cmr/my-ship-to/MyShipToView.vue'], resolve)
        },
        {
          path: '/cmr/MyShipToApprover',
          name: 'MyShipToApprover',
          component: resolve => require(['@/view/cmr/my-ship-to/MyShipToApprover.vue'], resolve)
        },
        {
          path: '/cmr/MyPosProductDetail',
          name: 'MyPosProductDetail',
          component: resolve => require(['@/view/cmr/post-master-data/MyPostProductDetail.vue'], resolve)
        },
        {
          path: '/cmr/CustomerProductMasterData',
          name: 'CustomerProductMasterData',
          component: resolve => require(['@/view/cmr/post-master-data/CustomerProductMasterData.vue'], resolve)
        },
        {
          path: '/cmr/POSProductBatchUpdate',
          name: 'POSProductBatchUpdate',
          component: resolve => require(['@/view/cmr/post-master-data/POSProductBatchUpdate.vue'], resolve)
        },
        {
          path: '/cmr/CustomerProductMasterDataUpdate',
          name: 'CustomerProductMasterDataUpdate',
          component: resolve => require(['@/view/cmr/post-master-data/CustomerProductMasterDataUpdate.vue'], resolve)
        },
        {
          path: '/cmr/MyRDProfile',
          name: 'MyRDProfile',
          component: resolve => require(['@/view/cmr/rd-profile/MyRDProfile.vue'], resolve)
        },
        {
          path: '/cmr/RDProfileEdit',
          name: 'RDProfileEdit',
          component: resolve => require(['@/view/cmr/rd-profile/RDProfileEdit.vue'], resolve)
        },
        {
          path: '/cmr/MyShiptoAssign',
          name: 'MyShiptoAssign',
          component: resolve => require(['@/view/cmr/my-ship-to/MyShipToAssign.vue'], resolve)
        },
        {
          path: '/cmr/MyShiptoTransfer',
          name: 'MyShiptoTransfer',
          component: resolve => require(['@/view/cmr/my-ship-to/MyShipToTransfer.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresAssign',
          name: 'MyStoresAssign',
          component: resolve => require(['@/view/cmr/my-stores/MyStoresAssign.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresTransfer',
          name: 'MyStoresTransfer',
          component: resolve => require(['@/view/cmr/my-stores/MyStoresTransfer.vue'], resolve)
        },
        {
          path: '/cmr/MyStoresApprovalConfirm',
          name: 'MyStoresApprovalConfirm',
          component: resolve => require(['@/view/cmr/my-stores/MyStoresApprovalConfirm.vue'], resolve)
        },
        {
          path: '/cmr/MyProfile',
          name: 'MyProfile',
          component: resolve => require(['@/view/cmr/my-profile/MyProfile.vue'], resolve)
        },
        {
          path: '/cmr/HierarchyChange',
          name: 'HierarchyChange',
          component: resolve => require(['@/view/cmr/hierarchy-change/HierarchyChange.vue'], resolve)
        },
        {
          path: '/cmr/MyResponsibility',
          name: 'MyResponsibility',
          component: resolve => require(['@/view/cmr/my-responsibility/MyResponsibility.vue'], resolve)
        },
        {
          path: '/cmr/ResponsibilityApprovalConfirm',
          name: 'ResponsibilityApprovalConfirm',
          component: resolve => require(['@/view/cmr/my-responsibility/ResponsibilityApprovalConfirm.vue'], resolve)
        },
        {
          path: '/cmr/MySurrogates',
          name: 'MySurrogates',
          component: resolve => require(['@/view/cmr/my-surrogates/MySurrogates.vue'], resolve)
        },
        {
          path: '/cmr/PartyRoleType',
          name: 'PartyRoleType',
          component: resolve => require(['@/view/cmr/data-maintenance/party-role-type/PartyRoleType.vue'], resolve)
        },
        {
          path: '/cmr/PartyRoleTypeCreate',
          name: 'PartyRoleTypeCreate',
          component: resolve => require(['@/view/cmr/data-maintenance/party-role-type/PartyRoleTypeCreate.vue'], resolve)
        },
        {
          path: '/cmr/PartyRoleTypeEdit',
          name: 'PartyRoleTypeEdit',
          component: resolve => require(['@/view/cmr/data-maintenance/party-role-type/PartyRoleTypeEdit.vue'], resolve)
        },
        {
          path: '/cmr/PartyType',
          name: 'PartyType',
          component: resolve => require(['@/view/cmr/data-maintenance/party-type/PartyType.vue'], resolve)
        },
        {
          path: '/cmr/PartyTypeCreate',
          name: 'PartyTypeCreate',
          component: resolve => require(['@/view/cmr/data-maintenance/party-type/PartyTypeCreate.vue'], resolve)
        },
        {
          path: '/cmr/PartyTypeEdit',
          name: 'PartyTypeEdit',
          component: resolve => require(['@/view/cmr/data-maintenance/party-type/PartyTypeEdit.vue'], resolve)
        },
        {
          path: '/cmr/EmployeeEdit',
          name: 'EmployeeEdit',
          component: resolve => require(['@/view/cmr/my-organization/EmployeeEdit.vue'], resolve)
        },
        {
          path: '/cmr/EmployeeDetails',
          name: 'EmployeeDetails',
          component: resolve => require(['@/view/cmr/my-organization/EmployeeDetails.vue'], resolve)
        },
        {
          path: '/cmr/MyRequests',
          name: 'MyRequests',
          component: resolve => require(['@/view/cmr_refactor/myRequests/index.vue'], resolve)
        },

        {
          path: '/cmr/TicketDetails',
          name: 'TicketDetails',
          component: resolve => require(['@/view/cmr/my-requests/TicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/EmployeeTicketDetails',
          name: 'EmployeeTicketDetails',
          component: resolve => require(['@/view/cmr_refactor/ticketDetail/index.vue'], resolve)
        },
        {
          path: '/cmr/TransferToTitketDetails',
          name: 'TransferToTitketDetails',
          component: resolve => require(['@/view/cmr/my-requests/TransferToTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/SissTicket',
          name: 'SissTicket',
          component: resolve => require(['@/view/cmr/my-requests/SissTicket.vue'], resolve)
        },
        {
          path: '/cmr/ShipToTransferTicketDetails',
          name: 'ShipToTransferTicketDetails',
          component: resolve => require(['@/view/cmr/my-requests/ShipToTransferTicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/ShipToTicketDetails',
          name: 'ShipToTicketDetails',
          component: resolve => require(['@/view/cmr/my-requests/ShipToTicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/RdTitketDetails',
          name: 'RdTitketDetails',
          component: resolve => require(['@/view/cmr/my-requests/RdTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/TradeFundTitketDetails',
          name: 'TradeFundTitketDetails',
          component: resolve => require(['@/view/cmr/my-requests/TradeFundTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/POSAccessTitketDetails',
          name: 'POSAccessTitketDetails',
          component: resolve => require(['@/view/cmr/my-requests/POSAccessTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/ServingInformationTitket',
          name: 'ServingInformationTitket',
          component: resolve => require(['@/view/cmr/my-requests/ServingInformationTitket.vue'], resolve)
        },
        {
          path: '/cmr/MRMediaFormatTitket',
          name: 'MRMediaFormatTitket',
          component: resolve => require(['@/view/cmr/my-requests/MRMediaFormatTitket.vue'], resolve)
        },
        {
          path: '/cmr/PeopleFinderSearch',
          name: 'PeopleFinderSearch',
          component: resolve => require(['@/view/cmr/people-finder/PeopleFinderSearch.vue'], resolve)
        },
        {
          path: '/cmr/PeopleFinderSearchList',
          name: 'PeopleFinderSearchList',
          component: resolve => require(['@/view/cmr/people-finder/PeopleFinderSearchList.vue'], resolve)
        },
        {
          path: '/cmr/PeopleFinderDetails',
          name: 'PeopleFinderDetails',
          component: resolve => require(['@/view/cmr/people-finder/PeopleFinderDetails.vue'], resolve)
        },
        {
          path: '/cmr/MyOrganization',
          name: 'MyOrganization',
          component: resolve => require(['@/view/cmr/my-organization/MyOrganization.vue'], resolve)
        },
        {
          path: '/cmr/ContactList',
          name: 'ContactList',
          component: resolve => require(['@/view/cmr/report-center/ContactList.vue'], resolve)
        },
        {
          path: '/cmr/ServingInformationReport',
          name: 'ServingInformationReport',
          component: resolve => require(['@/view/cmr/downstream-access/ServingInformationReport.vue'], resolve)
        },
        {
          path: '/cmr/PartyRelType',
          name: 'PartyRelType',
          component: resolve => require(['@/view/cmr/data-maintenance/party-rel-type/PartyRelType.vue'], resolve)
        },
        {
          path: '/cmr/PartyRelTypeAdd',
          name: 'PartyRelTypeAdd',
          component: resolve => require(['@/view/cmr/data-maintenance/party-rel-type/PartyRelTypeAdd.vue'], resolve)
        },
        {
          path: '/cmr/AdminAssignStore',
          name: 'AdminAssignStore',
          component: resolve => require(['@/view/cmr/data-maintenance/AdminAssignStore.vue'], resolve)
        },
        {
          path: '/cmr/AdminAssignShipTo',
          name: 'AdminAssignShipTo',
          component: resolve => require(['@/view/cmr/data-maintenance/AdminAssignShipTo.vue'], resolve)
        },
        {
          path: '/cmr/AdminChangeStoreType',
          name: 'AdminChangeStoreType',
          component: resolve => require(['@/view/cmr/data-maintenance/ChangeStoreType.vue'], resolve)
        },
        {
          path: '/cmr/AdminChangeStoreStatus',
          name: 'AdminChangeStoreStatus',
          component: resolve => require(['@/view/cmr/data-maintenance/AdminChangeStoreStatus.vue'], resolve)
        },
        {
          path: '/cmr/AdminChangeShiptoType',
          name: 'AdminChangeShiptoType',
          component: resolve => require(['@/view/cmr/data-maintenance/AdminChangeShiptoType.vue'], resolve)
        },
        {
          path: '/cmr/ShipToType',
          name: 'ShipToType',
          component: resolve => require(['@/view/cmr/data-maintenance/ship-to-type/ShipToType.vue'], resolve)
        },
        {
          path: '/cmr/ShipToTypeAdd',
          name: 'ShipToTypeAdd',
          component: resolve => require(['@/view/cmr/data-maintenance/ship-to-type/ShipToTypeAdd.vue'], resolve)
        },
        {
          path: '/cmr/ShipToTypeEdit',
          name: 'ShipToTypeEdit',
          component: resolve => require(['@/view/cmr/data-maintenance/ship-to-type/ShipToTypeEdit.vue'], resolve)
        },
        {
          path: '/cmr/MyToDoList',
          name: 'MyToDoList',
          component: resolve => require(['@/view/cmr_refactor/todolist/index.vue'], resolve)
        },
        {
          path: '/cmr/psEmployeeRoleTitketDetails',
          name: 'psEmployeeRoleTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/psEmployeeRoleTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLTradeFundTitketDetails',
          name: 'MTLTradeFundTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/TradeFundTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLTransferToTitketDetails',
          name: 'MTLTransferToTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/TransferToTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLEmployeeTicketDetails',
          name: 'MTLEmployeeTicketDetails',
          component: resolve => require(['@/view/cmr_refactor/ticketDetail/index.vue'], resolve)
        },
        {
          path: '/product-ticket-details',
          name: 'ProductTicketDetails',
          component: resolve => require(['@/view/cmr_refactor/ticketDetail/product.vue'], resolve)
        },
        {
          path: '/cmr/MTLPOSAccessTitketDetails',
          name: 'MTLPOSAccessTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/POSAccessTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLRdTitketDetails',
          name: 'MTLRdTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/RdTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/batchMaintainTitketDetails',
          name: 'batchMaintainTitketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/batchMaintainTitketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLServingInformationTitket',
          name: 'MTLServingInformationTitket',
          component: resolve => require(['@/view/cmr/my-to-do-list/ServingInformationTitket.vue'], resolve)
        },
        {
          path: '/cmr/MediaFormatTitket',
          name: 'MediaFormatTitket',
          component: resolve => require(['@/view/cmr/my-to-do-list/MediaFormatTitket.vue'], resolve)
        },
        {
          path: '/cmr/MTLShipToTicketDetails',
          name: 'MTLShipToTicketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/ShipToTicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLShipToTransferTicketDetails',
          name: 'MTLShipToTransferTicketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/ShipToTransferTicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/MTLSissTicket',
          name: 'MTLSissTicket',
          component: resolve => require(['@/view/cmr/my-to-do-list/SissTicket.vue'], resolve)
        },
        {
          path: '/cmr/MTLTicketDetails',
          name: 'MTLTicketDetails',
          component: resolve => require(['@/view/cmr/my-to-do-list/TicketDetails.vue'], resolve)
        },
        {
          path: '/cmr/RefreshCacheData',
          name: 'RefreshCacheData',
          component: resolve => require(['@/view/cmr/System/RefreshCacheData.vue'], resolve)
        },
        {
          path: '/cmr/AdminResponsibility',
          name: 'AdminResponsibility',
          component: resolve => require(['@/view/cmr/System/AdminResponsibility.vue'], resolve)
        },
        {
          path: '/cmr/SPIGDiscountGuidance',
          name: 'SPIGDiscountGuidance',
          component: resolve => require(['@/view/cmr/report-center/MPIPDiscountGuidance.vue'], resolve)
        },
        {
          path: '/cmr/UserLogs',
          name: 'UserLogs',
          component: resolve => require(['@/view/cmr/logs/UserLogs.vue'], resolve)
        },
        {
          path: '/cmr/UserLogDetails',
          name: 'UserLogDetails',
          component: resolve => require(['@/view/cmr/logs/UserLogDetails.vue'], resolve)
        },
        {
          path: '/cmr/DataLogs',
          name: 'DataLogs',
          component: resolve => require(['@/view/cmr/logs/DataLogs.vue'], resolve)
        },
        {
          path: '/cmr/DataLogDetails',
          name: 'DataLogDetails',
          component: resolve => require(['@/view/cmr/logs/DataLogDetails.vue'], resolve)
        },
        {
          path: '/cmr/FunctionLogs',
          name: 'FunctionLogs',
          component: resolve => require(['@/view/cmr/logs/FunctionLogs.vue'], resolve)
        },
        {
          path: '/cmr/FunctionLogDetails',
          name: 'FunctionLogDetails',
          component: resolve => require(['@/view/cmr/logs/FunctionLogDetails.vue'], resolve)
        },
        {
          path: '/cmr/ReportingLevel',
          name: 'ReportingLevel',
          component: resolve => require(['@/view/cmr/bu-attributes/ReportingLevel.vue'], resolve)
        },
        {
          path: '/cmr/ReportingLevelEdit',
          name: 'ReportingLevelEdit',
          component: resolve => require(['@/view/cmr/bu-attributes/ReportingLevelEdit.vue'], resolve)
        },
        {
          path: '/cmr/ReportingLevelLog',
          name: 'ReportingLevelLog',
          component: resolve => require(['@/view/cmr/bu-attributes/ReportingLevelLog.vue'], resolve)
        },
        {
          path: '/cmr/RequestTradeFundGoldmine',
          name: 'RequestTradeFundGoldmine',
          component: resolve => require(['@/view/cmr/my-responsibility/RequestTradeFundGoldmine.vue'], resolve)
        },
        {
          path: '/cmr/RequestTradeFundDMC',
          name: 'RequestTradeFundDMC',
          component: resolve => require(['@/view/cmr/my-responsibility/RequestTradeFundDMC.vue'], resolve)
        },
        {
          path: '/cmr/RequestTradeFundORC',
          name: 'RequestTradeFundORC',
          component: resolve => require(['@/view/cmr/my-responsibility/RequestTradeFundORC.vue'], resolve)
        },
        {
          path: '/cmr/RequestTradeFundDefault',
          name: 'RequestTradeFundDefault',
          component: resolve => require(['@/view/cmr_refactor/my-responsibility/tradeFund/index.vue'], resolve)
        },
        {
          path: '/cmr/EditServingInformation',
          name: 'EditServingInformation',
          component: resolve => require(['@/view/cmr/my-responsibility/EditServingInformation.vue'], resolve)
        },
        {
          path: '/cmr/RoleResponsibilityReview',
          name: 'RoleResponsibilityReview',
          component: resolve => require(['@/view/cmr/profile/RoleResponsibilityReview.vue'], resolve)
        },
        {
          path: '/cmr/TradeFundAccess',
          name: 'TradeFundAccess',
          component: resolve => require(['@/view/cmr/downstream-access/TradeFundAccess.vue'], resolve)
        },
        {
          path: '/cmr/POSDataAccess',
          name: 'POSDataAccess',
          component: resolve => require(['@/view/cmr/downstream-access/POSDataAccess.vue'], resolve)
        },
        {
          path: '/cmr/SystemAccessApplicationLog',
          name: 'SystemAccessApplicationLog',
          component: resolve => require(['@/view/cmr/downstream-access/SystemAccessApplicationLog.vue'], resolve)
        },
        {
          path: '/cmr/triggerBPProcess',
          name: 'triggerBPProcess',
          component: resolve => require(['@/view/cmr/trigger-BP-manage/triggerBPProcess.vue'], resolve)
        },{
          path: '/cmr/hrBatchUploadPs',
          name: 'hrBatchUploadPs',
          component: resolve => require(['@/view/cmr/trigger-BP-manage/hrBatchUploadPs.vue'], resolve)
        },{
          path: '/cmr/dataInputFormPs',
          name: 'dataInputFormPs',
          component: resolve => require(['@/view/cmr/trigger-BP-manage/DataInputFormPs.vue'], resolve)
        },
        {
          path: '/cmr/DataInputListPs',
          name: 'DataInputListPs',
          component: resolve => require(['@/view/cmr/trigger-BP-manage/DataInputListPs.vue'], resolve)
        },
        {
          path: '/cmr/diffCustomerHierarchy',
          name: 'diffCustomerHierarchy',
          component: resolve => require(['@/view/cmr/diff-customer-hierarchy/index.vue'], resolve)
        },
        ...productPrice, // Product/Price的路由管理
        ...dashboard, // Dashboard
        ...cmr, // CMR
        ...mdm
      ]
    },
    {
      path: '/mobile',
      name: 'mobile',
      redirect: '/login',
      component: resolve => require(['@/containers/mobile'], resolve),
      children: [
        {
          path: 'home',
          name: 'mobileHome',
          component: resolve => require(['@/view/home/home'], resolve)
        },
        {
          path: 'poh',
          name: 'pohMobile',
          component: resolve => require(['@/view/mobile/POH/index.vue'], resolve),
          children: [
            {
              path: 'maintain',
              name: 'maintain',
              component: resolve => require(['@/view/mobile/POH/maintain.vue'], resolve)
            },
            {
              path: 'clinic-master-data',
              name: 'clinic-master-data',
              component: resolve => require(['@/view/mobile/POH/clinic-master-data/index.vue'], resolve)
            },
            {
              path: 'detail',
              name: 'Clinics',
              component: resolve => require(['@/view/mobile/POH/newClinics/index.vue'], resolve)
            },
            {
              path: 'dental',
              name: 'dental',
              component: resolve => require(['@/view/mobile/POH/dental/index.vue'], resolve)
            },
            {
              path: 'dental-master-data',
              name: 'dental-master-data',
              component: resolve => require(['@/view/mobile/POH/dental-master-data/index.vue'], resolve)
            },
            {
              path: 'clinic-draft',
              name: 'mb-clinic-draft',
              component: resolve => require(['@/view/mobile/POH/draft/index.vue'], resolve)
            },
            {
              path: 'delegation',
              name: 'mb-delegation',
              component: resolve => require(['@/view/mobile/POH/delegation/index.vue'], resolve)
            },
          ]
        },
        {
          path: 'backlog',
          name: 'backlog',
          component: resolve => require(['@/view/mobile/POH/todolist.vue'], resolve)
        }
      ]
    },
    {
      path: '/d1-mgmt',
      name: 'd1-mgmt',
      component: resolve => require(['@/components/d1/container'], resolve)
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/view/index'], resolve),
      meta: {
        title: 'D1 Demo Page'
      }
    },
    {
      path: '/common-view',
      name: 'commonView',
      component: resolve => require(['@/components/d1/common-view'], resolve)
    },
    {
      path: '/sample-view',
      name: 'sampleView',
      component: resolve => require(['@/components/d1/sample-view'], resolve)
    },
    {
      path: '/login',
      name: 'login',
      component: resolve => require(['@/view/login'], resolve)
    },
    {
      path: '/logout',
      name: 'logout',
      component: resolve => require(['@/view/logout'], resolve)
    },
    {
      path: '/local-temporary-lander',
      name: 'login',
      component: resolve => require(['@/view/login-local'], resolve)
    },
    {
      path: '/test-tree',
      name: 'test-tree',
      component: testTree
    },
    {
      path: '/switch-role',
      name: 'switch-role',
      component: switchRole
    },
    {
      path: '/picture-display',
      name: 'picture-display',
      component: pictureDisplay
    },
    { //版本维护页面的路由
      path:'/version-maintenance',
      name:'version-maintenance',
      component:versionMaintenance
    },
    {
      path: '/downFile',
      name: 'downFile',
      component: resolve => require(['@/components/downFile/index.vue'], resolve)
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js